/*
 * This file is a generated Typescript file for GRPC Gateway, DO NOT MODIFY
 */

import * as fm from "../../../fm"


/**
 * Сервис реализует функционал управления объектами строительства телеметрии
 */

/**
 * Сервис управления объектами строительства телеметрии.
 * Авторизация:
 *   - Authorization: Bearer token.
 *   - X-Api-Key: apiKey
 */
export class BuildingServiceClient {
  /**
   * Конструктор сервиса
   * @param host Адрес хоста
   * @param token Токен доступа
   */
  constructor(
    public host = "",
    public token = ""
  ) { }

  /**
   * Метод получения объекта строительства.
   * Разрешения: telemetry_control:building:card, telemetry_control:building:card:own.
   * Метод доступен для: Token: admin, service, bti, seller, application, owner, employee. При наличии разрешений.
   * Метод доступен для: ApiKey: При наличии разрешений
   */
  GetBuilding = (req: GetBuildingRequestDto, init?: RequestInit): Promise<GetBuildingResponseDto> => {
    return fm.request<GetBuildingRequestDto, GetBuildingResponseDto>(`${this.host}/telemetry_control/api/v1/building/${encodeURIComponent(req.id)}${fm.buildQuery(req, ["id"])}`, { ...init, method: "GET", ...{ headers: { ...init?.headers, ...{ 'Authorization': `Bearer ${this.token}` } } } })
  }

  /**
   * Метод получения списка объектов строительства.
   * Разрешения: telemetry_control:building:list, telemetry_control:building:list:own.
   * Метод доступен для: Token: admin, service, bti, seller, application, owner, employee. При наличии разрешений.
   * Метод доступен для: ApiKey: При наличии разрешений
   */
  GetBuildingList = (req?: GetBuildingListRequestDto, init?: RequestInit): Promise<GetBuildingListResponseDto[]> => {
    return fm.list<GetBuildingListRequestDto, GetBuildingListResponseDto>(`${this.host}/telemetry_control/api/v1/building/list${fm.buildQuery(req)}`, {...init, method: "GET", ...{ headers: { ...init?.headers, ...{ 'Authorization': `Bearer ${this.token}` } } } })
  }
  /**
   * Метод получения количества объектов строительства.
   * Разрешения: telemetry_control:building:list, telemetry_control:building:list:own.
   * Метод доступен для: Token: admin, service, bti, seller, application, owner, employee. При наличии разрешений.
   * Метод доступен для: ApiKey: При наличии разрешений
   */
  GetBuildingCount = (req?: GetBuildingCountRequestDto, init?: RequestInit): Promise<GetBuildingCountResponseDto> => {
    return fm.request<GetBuildingCountRequestDto, GetBuildingCountResponseDto>(`${this.host}/telemetry_control/api/v1/building/count${fm.buildQuery(req)}`, { ...init, method: "GET", ...{ headers: { ...init?.headers, ...{ 'Authorization': `Bearer ${this.token}` } } } })
  }

  /**
   * Метод сохранения объекта строительства.
   * Поддерживает создание и обновление.
   * Разрешения: telemetry_control:building:save, telemetry_control:building:save:own.
   * Метод доступен для: Token: admin, service, bti, seller, application, owner, employee. При наличии разрешений
   */
  PostBuilding = (req: PostBuildingRequestDto, init?: RequestInit): Promise<PostBuildingResponseDto> => {
    return fm.request<PostBuildingRequestDto, PostBuildingResponseDto>(`${this.host}/telemetry_control/api/v1/building`, { ...init, method: "POST", body: JSON.stringify(req, fm.replacer), ...{ headers: { ...init?.headers, ...{ 'Authorization': `Bearer ${this.token}` } } } })
  }

  // method PostBuildingFullDuplex(bidirectional streams) not supported yet

  /**
   * Метод удаления объекта строительства.
   * Разрешения: telemetry_control:building:remove, telemetry_control:building:remove:own.
   * Метод доступен для: admin, service, bti, seller, application, owner, employee. При наличии разрешений
   */
  DeleteBuilding = (req: DeleteBuildingRequestDto, init?: RequestInit): Promise<DeleteBuildingResponseDto> => {
    return fm.request<DeleteBuildingRequestDto, DeleteBuildingResponseDto>(`${this.host}/telemetry_control/api/v1/building/${encodeURIComponent(req.id)}${fm.buildQuery(req, ["id"])}`, { ...init, method: "DELETE", ...{ headers: { ...init?.headers, ...{ 'Authorization': `Bearer ${this.token}` } } } })
  }

  /**
   * Метод получения списка связей объектов строительства и группы пользователя.
   * Метод доступен для: Token: admin, service, bti, seller. Без учета разрешений
   */
  GetBuildingGroupList = (req?: GetBuildingGroupListRequestDto, init?: RequestInit): Promise<GetBuildingGroupListResponseDto[]> => {
    return fm.list<GetBuildingGroupListRequestDto, GetBuildingGroupListResponseDto>(`${this.host}/telemetry_control/api/v1/building/group/list${fm.buildQuery(req)}`, {...init, method: "GET", ...{ headers: { ...init?.headers, ...{ 'Authorization': `Bearer ${this.token}` } } } })
  }
  /**
   * Метод получения количества связей объектов строительства и группы пользователя.
   * Метод доступен для: Token: admin, service, bti, seller. Без учета разрешений
   */
  GetBuildingGroupCount = (req?: GetBuildingGroupCountRequestDto, init?: RequestInit): Promise<GetBuildingGroupCountResponseDto> => {
    return fm.request<GetBuildingGroupCountRequestDto, GetBuildingGroupCountResponseDto>(`${this.host}/telemetry_control/api/v1/building/group/count${fm.buildQuery(req)}`, { ...init, method: "GET", ...{ headers: { ...init?.headers, ...{ 'Authorization': `Bearer ${this.token}` } } } })
  }

  /**
   * Метод сохранения связей объектов строительства и группы пользователя.
   * Поддерживает только создание.
   * Метод доступен для: Token: admin, service, bti, seller. Без учета разрешений
   */
  PutBuildingGroupAttach = (req: PutBuildingGroupAttachRequestDto, init?: RequestInit): Promise<PutBuildingGroupAttachResponseDto> => {
    return fm.request<PutBuildingGroupAttachRequestDto, PutBuildingGroupAttachResponseDto>(`${this.host}/telemetry_control/api/v1/building/${encodeURIComponent(req.buildingGroup.buildingId)}/group/${encodeURIComponent(req.buildingGroup.groupId)}/attach`, { ...init, method: "PUT", body: JSON.stringify(req, fm.replacer), ...{ headers: { ...init?.headers, ...{ 'Authorization': `Bearer ${this.token}` } } } })
  }

  /**
   * Метод удаления связей объектов строительства и группы пользователя.
   * Метод доступен для: Token: admin, service, bti, seller. Без учета разрешений
   */
  PutBuildingGroupDetach = (req: PutBuildingGroupDetachRequestDto, init?: RequestInit): Promise<PutBuildingGroupDetachResponseDto> => {
    return fm.request<PutBuildingGroupDetachRequestDto, PutBuildingGroupDetachResponseDto>(`${this.host}/telemetry_control/api/v1/building/${encodeURIComponent(req.buildingGroup.buildingId)}/group/${encodeURIComponent(req.buildingGroup.groupId)}/detach`, { ...init, method: "PUT", body: JSON.stringify(req, fm.replacer), ...{ headers: { ...init?.headers, ...{ 'Authorization': `Bearer ${this.token}` } } } })
  }

}

/**
 * Справочник МРФ (Макрорегионы)
 */
export enum BuildingMrfType {
  /**
   * Значение не указано
   */
  MRF_TYPE_UNKNOWN = "MRF_TYPE_UNKNOWN",
  /**
   * Центр
   */
  TSENTR = "TSENTR",
  /**
   * Юг
   */
  YUG = "YUG",
  /**
   * Урал
   */
  URAL = "URAL",
  /**
   * Сибирь
   */
  SIBIR = "SIBIR",
  /**
   * Северо-Запад
   */
  SEVERO_ZAPAD = "SEVERO_ZAPAD",
  /**
   * Дальний Восток
   */
  DALNIY_VOSTOK = "DALNIY_VOSTOK",
  /**
   * Волга
   */
  VOLGA = "VOLGA",
}
/**
 * Справочник МРФ (Макрорегионы)
 */
export type BuildingMrfTypeResponseEnum = keyof typeof BuildingMrfType
/**
 * Справочник МРФ (Макрорегионы)
 */
export type BuildingMrfTypeRequestEnum = Exclude<BuildingMrfTypeResponseEnum, "MRF_TYPE_UNKNOWN">;

/**
 * Справочник РФ (Регионы)
 */
export enum BuildingRfType {
  /**
   * Значение не указано
   */
  RF_TYPE_UNKNOWN = "RF_TYPE_UNKNOWN",
  /**
   * Республика Башкортостан
   */
  UFA = "UFA",
  /**
   * Кировская область
   */
  KIROV = "KIROV",
  /**
   * Ивановский филиал
   */
  IVANOVO = "IVANOVO",
  /**
   * Калужский филиал
   */
  KALUGA = "KALUGA",
  /**
   * Костромской филиал
   */
  KOSTROMA = "KOSTROMA",
  /**
   * Курский филиал
   */
  KURSK = "KURSK",
  /**
   * Липецкий филиал
   */
  LIPETSK = "LIPETSK",
  /**
   * Московская область
   */
  MOSOBLAST = "MOSOBLAST",
  /**
   * Орловский филиал
   */
  OREL = "OREL",
  /**
   * Рязанский филиал
   */
  RYAZAN = "RYAZAN",
  /**
   * Тамбовский филиал
   */
  TAMBOV = "TAMBOV",
  /**
   * Тверской филиал
   */
  TVER = "TVER",
  /**
   * Ярославский филиал
   */
  YAROSLAVL = "YAROSLAVL",
  /**
   * Смоленский филиал
   */
  SMOLENSK = "SMOLENSK",
  /**
   * Тульский филиал
   */
  TULA = "TULA",
  /**
   * Москва
   */
  MOSCOW = "MOSCOW",
  /**
   * ЕАО
   */
  EAO = "EAO",
  /**
   * Филиал в Тюменской и Курганской областях
   */
  KURGAN = "KURGAN",
  /**
   * Филиал в Тюменской и Курганской областях
   */
  TUMEN = "TUMEN",
  /**
   * Ханты-Мансийский филиал
   */
  HANTY = "HANTY",
  /**
   * Амурская область
   */
  AMUR = "AMUR",
  /**
   * Камчатский край
   */
  KAMCHATKA = "KAMCHATKA",
  /**
   * Магаданская область
   */
  MAGADAN = "MAGADAN",
  /**
   * Приморский край
   */
  PRIMORYE = "PRIMORYE",
  /**
   * Сахалинская область
   */
  SAKHALIN = "SAKHALIN",
  /**
   * Хабаровский край
   */
  KHABAROVSK = "KHABAROVSK",
  /**
   * Забайкальский край
   */
  CHITA = "CHITA",
  /**
   * ЧАО
   */
  CHUKOTKA = "CHUKOTKA",
  /**
   * Архангельск
   */
  ARCHANGELSK = "ARCHANGELSK",
  /**
   * Вологда
   */
  VOLOGDA = "VOLOGDA",
  /**
   * Калининград
   */
  KALININGRAD = "KALININGRAD",
  /**
   * Карелия
   */
  KARELIA = "KARELIA",
  /**
   * Коми
   */
  KOMI = "KOMI",
  /**
   * Лен область
   */
  LENOBLAST = "LENOBLAST",
  /**
   * Мурманск
   */
  MURMANSK = "MURMANSK",
  /**
   * Новгород
   */
  NOVGOROD = "NOVGOROD",
  /**
   * Псков
   */
  PSKOV = "PSKOV",
  /**
   * СПб
   */
  SPB = "SPB",
  /**
   * Алтайский филиал
   */
  ALTAI = "ALTAI",
  /**
   * Бурятский филиал
   */
  BURYATIYA = "BURYATIYA",
  /**
   * Иркутский филиал
   */
  IRKUTSK = "IRKUTSK",
  /**
   * Кемеровский филиал
   */
  KEMEROVO = "KEMEROVO",
  /**
   * Красноярский филиал
   */
  KRASNOYARSK = "KRASNOYARSK",
  /**
   * Омский филиал
   */
  OMSK = "OMSK",
  /**
   * Республика Хакасия
   */
  HAKASIYA = "HAKASIYA",
  /**
   * Республика Алтай
   */
  RALTAY = "RALTAY",
  /**
   * Республика Тыва
   */
  TUVA = "TUVA",
  /**
   * Томский филиал
   */
  TOMSK = "TOMSK",
  /**
   * Оренбургская область
   */
  ORENBURG = "ORENBURG",
  /**
   * Белгородский филиал
   */
  BELGOROD = "BELGOROD",
  /**
   * Саха
   */
  SAKHA = "SAKHA",
  /**
   * Екатеринбургский филиал
   */
  EKT = "EKT",
  /**
   * Волгоградский филиал
   */
  VOLGOGRAD = "VOLGOGRAD",
  /**
   * Ямало-Ненецкий филиал
   */
  YAMAL = "YAMAL",
  /**
   * Челябинский филиал
   */
  CHELYABINSK = "CHELYABINSK",
  /**
   * Пермский филиал ПАО \"Ростелеком\"
   */
  PERM = "PERM",
  /**
   * Республика Марий Эл
   */
  MARYEL = "MARYEL",
  /**
   * Пензенская область
   */
  PENZA = "PENZA",
  /**
   * Ингушский филиал
   */
  INGUSHETIA = "INGUSHETIA",
  /**
   * Кабардино-Балкарский филиал
   */
  NALCHIK = "NALCHIK",
  /**
   * Калмыцкий филиал
   */
  ELISTA = "ELISTA",
  /**
   * Ростовский филиал
   */
  ROSTOV = "ROSTOV",
  /**
   * Дагестанский филиал
   */
  MAHACHKALA = "MAHACHKALA",
  /**
   * Республика Мордовия
   */
  MORDOVIYA = "MORDOVIYA",
  /**
   * Республика Татарстан (Татарстан)
   */
  KAZAN = "KAZAN",
  /**
   * Самарская область
   */
  SAMARA = "SAMARA",
  /**
   * Саратовская область
   */
  SARATOV = "SARATOV",
  /**
   * Удмуртская Республика
   */
  UDMURTIYA = "UDMURTIYA",
  /**
   * Ульяновская область
   */
  ULYANOVSK = "ULYANOVSK",
  /**
   * Чувашская Республика - Чувашия
   */
  CHUVASHIYA = "CHUVASHIYA",
  /**
   * Нижегородская область
   */
  NNOVGOROD = "NNOVGOROD",
  /**
   * Брянский филиал
   */
  BRYANSK = "BRYANSK",
  /**
   * Владимирский филиал
   */
  VLADIMIR = "VLADIMIR",
  /**
   * Воронежский филиал
   */
  VORONEZH = "VORONEZH",
  /**
   * Северо-Осетинский филиал
   */
  VLADIKAVKAZ = "VLADIKAVKAZ",
  /**
   * Ставропольский филиал
   */
  STAVROPOL = "STAVROPOL",
  /**
   * Республика Карачаево-Черкесская
   */
  CHERKESSK = "CHERKESSK",
  /**
   * Республика Адыгея
   */
  MAYKOP = "MAYKOP",
  /**
   * Астраханский филиал
   */
  ASTRAKHAN = "ASTRAKHAN",
  /**
   * Краснодарский филиал
   */
  KRASNODAR = "KRASNODAR",
  /**
   * Тестовый
   */
  TEST = "TEST",
  /**
   * Новосибирский филиал
   */
  NOVOSIBIRSK = "NOVOSIBIRSK",
}
/**
 * Справочник РФ (Регионы)
 */
export type BuildingRfTypeResponseEnum = keyof typeof BuildingRfType
/**
 * Справочник РФ (Регионы)
 */
export type BuildingRfTypeRequestEnum = Exclude<BuildingRfTypeResponseEnum, "RF_TYPE_UNKNOWN">;

/**
 * Статусы объектов строительства
 */
export enum BuildingStatusType {
  /**
   * Значение не указано
   */
  STATUS_TYPE_UNKNOWN = "STATUS_TYPE_UNKNOWN",
  /**
   * СМР
   */
  BUILDING = "BUILDING",
  /**
   * Реализован
   */
  ACCEPTANCE = "ACCEPTANCE",
  /**
   * Обслуживание
   */
  ACTIVE = "ACTIVE",
  /**
   * Снят с обслуживания
   */
  ARCHIVE = "ARCHIVE",
  /**
   * Отказ от заключения договора
   */
  CANCELLED = "CANCELLED",
  /**
   * Тестовый
   */
  TEST_STATUS_TYPE = "TEST_STATUS_TYPE",
}
/**
 * Статусы объектов строительства
 */
export type BuildingStatusTypeResponseEnum = keyof typeof BuildingStatusType
/**
 * Статусы объектов строительства
 */
export type BuildingStatusTypeRequestEnum = Exclude<BuildingStatusTypeResponseEnum, "STATUS_TYPE_UNKNOWN">;

/**
 * Справочник типов направлений сортировки
 */
export enum BuildingGroupPagingDirectionType {
  /**
   * Значение не указано
   */
  DIRECTION_TYPE_UNKNOWN = "DIRECTION_TYPE_UNKNOWN",
  /**
   * От большего к меньшему
   */
  DESC = "DESC",
  /**
   * От меньшего к большему
   */
  ASC = "ASC",
}
/**
 * Справочник типов направлений сортировки
 */
export type BuildingGroupPagingDirectionTypeResponseEnum = keyof typeof BuildingGroupPagingDirectionType
/**
 * Справочник типов направлений сортировки
 */
export type BuildingGroupPagingDirectionTypeRequestEnum = Exclude<BuildingGroupPagingDirectionTypeResponseEnum, "DIRECTION_TYPE_UNKNOWN">;

/**
 * Справочник типов сортировки
 */
export enum BuildingGroupPagingOrderByType {
  /**
   * Значение не указано
   */
  ORDER_BY_TYPE_UNKNOWN = "ORDER_BY_TYPE_UNKNOWN",
  /**
   * По Идентификатору группы пользователя
   */
  GROUP_ID = "GROUP_ID",
  /**
   * По Объекту строительства
   */
  BUILDING_ID = "BUILDING_ID",
}
/**
 * Справочник типов сортировки
 */
export type BuildingGroupPagingOrderByTypeResponseEnum = keyof typeof BuildingGroupPagingOrderByType
/**
 * Справочник типов сортировки
 */
export type BuildingGroupPagingOrderByTypeRequestEnum = Exclude<BuildingGroupPagingOrderByTypeResponseEnum, "ORDER_BY_TYPE_UNKNOWN">;

/**
 * Справочник типов направлений сортировки
 */
export enum BuildingPagingDirectionType {
  /**
   * Значение не указано
   */
  DIRECTION_TYPE_UNKNOWN = "DIRECTION_TYPE_UNKNOWN",
  /**
   * От большего к меньшему
   */
  DESC = "DESC",
  /**
   * От меньшего к большему
   */
  ASC = "ASC",
}
/**
 * Справочник типов направлений сортировки
 */
export type BuildingPagingDirectionTypeResponseEnum = keyof typeof BuildingPagingDirectionType
/**
 * Справочник типов направлений сортировки
 */
export type BuildingPagingDirectionTypeRequestEnum = Exclude<BuildingPagingDirectionTypeResponseEnum, "DIRECTION_TYPE_UNKNOWN">;

/**
 * Справочник типов сортировки
 */
export enum BuildingPagingOrderByType {
  /**
   * Значение не указано
   */
  ORDER_BY_TYPE_UNKNOWN = "ORDER_BY_TYPE_UNKNOWN",
  /**
   * По уникальному ключу
   */
  ID = "ID",
  /**
   * По наименованию
   */
  TITLE = "TITLE",
  /**
   * По дате создания
   */
  CREATED_AT = "CREATED_AT",
  /**
   * По дате изменения
   */
  CHANGED_AT = "CHANGED_AT",
  /**
   * По ФИАС
   */
  FIAS_ID = "FIAS_ID",
}
/**
 * Справочник типов сортировки
 */
export type BuildingPagingOrderByTypeResponseEnum = keyof typeof BuildingPagingOrderByType
/**
 * Справочник типов сортировки
 */
export type BuildingPagingOrderByTypeRequestEnum = Exclude<BuildingPagingOrderByTypeResponseEnum, "ORDER_BY_TYPE_UNKNOWN">;

/**
 * Объект строительства
 */
export type BuildingRequestDto = {
  /**
   * Идентификатор
   */
  id?: number
  /**
   * Наименование объекта строительства
   */
  title?: string
  /**
   * Смещение временной зоны объекта строительства от UTC в минутах
   */
  utcOffset: number
  /**
   * ФИАС
   */
  fiasId?: string | null
  /**
   * Принадлежность объекта строительства к МРФ
   */
  mrfType?: BuildingMrfTypeRequestEnum | "MRF_TYPE_UNKNOWN"
  /**
   * Принадлежность объекта строительства к РФ
   */
  rfType?: BuildingRfTypeRequestEnum | "RF_TYPE_UNKNOWN"
  /**
   * Статус объекта строительства
   */
  statusType?: BuildingStatusTypeRequestEnum | "STATUS_TYPE_UNKNOWN"
  /**
   * Адрес объекта строительства
   */
  fullAddress?: string
  /**
   * ОРПОН
   */
  orpon?: string
}
/**
 * Объект строительства
 */
export type BuildingResponseDto = {
  /**
   * Идентификатор
   */
  id: number
  /**
   * Наименование объекта строительства
   */
  title: string
  /**
   * Дата создания
   */
  readonly createdAt: string
  /**
   * Дата последнего изменения.
   * Заполняется и обновляется сервером.
   * Заполняется при создании и изменении.
   * Является версией объекта
   */
  readonly changedAt: string
  /**
   * Смещение временной зоны объекта строительства от UTC в минутах
   */
  utcOffset: number
  /**
   * ФИАС
   */
  fiasId: string | null
  /**
   * Принадлежность объекта строительства к МРФ
   */
  mrfType: BuildingMrfTypeResponseEnum
  /**
   * Принадлежность объекта строительства к РФ
   */
  rfType: BuildingRfTypeResponseEnum
  /**
   * Статус объекта строительства
   */
  statusType: BuildingStatusTypeResponseEnum
  /**
   * Адрес объекта строительства
   */
  fullAddress: string
  /**
   * ОРПОН
   */
  orpon: string
}
/**
 * Фильтр для запроса объектов строительства.
 * При передаче массива в параметр фильтра элементы массива работают в выборке через ИЛИ.
 * При передаче нескольких разных параметров фильтра они работают в выборке через И
 */
export type BuildingFilterRequestDto = {
  /**
   * По ФИАС
   */
  fiasId?: string[]
  /**
   * По заголовку
   */
  title?: string | null
  /**
   * По нижней границе дате создания
   */
  afterCreatedAt?: string | null
  /**
   * По верхней границе дате создания
   */
  beforeCreatedAt?: string | null
  /**
   * По МРФ (Макрорегион)
   */
  mrfTypes?: BuildingMrfTypeResponseEnum[]
  /**
   * По РФ (Регион)
   */
  rfTypes?: BuildingRfTypeResponseEnum[]
  /**
   * По статусам объекта строительства
   */
  statusTypes?: BuildingStatusTypeResponseEnum[]
  /**
   * По ОРПОНам
   */
  orpons?: string[]
}
/**
 * Фильтр для запроса объектов строительства.
 * При передаче массива в параметр фильтра элементы массива работают в выборке через ИЛИ.
 * При передаче нескольких разных параметров фильтра они работают в выборке через И
 */
export type BuildingFilterResponseDto = {
  /**
   * По ФИАС
   */
  fiasId: string[]
  /**
   * По заголовку
   */
  title: string | null
  /**
   * По нижней границе дате создания
   */
  afterCreatedAt: string | null
  /**
   * По верхней границе дате создания
   */
  beforeCreatedAt: string | null
  /**
   * По МРФ (Макрорегион)
   */
  mrfTypes: BuildingMrfTypeResponseEnum[]
  /**
   * По РФ (Регион)
   */
  rfTypes: BuildingRfTypeResponseEnum[]
  /**
   * По статусам объекта строительства
   */
  statusTypes: BuildingStatusTypeResponseEnum[]
  /**
   * По ОРПОНам
   */
  orpons: string[]
}
/**
 * Связка объекта строительства и группы пользователя.
 * Задает область ресурсов (resource scope), доступную пользователю.
 * Используется для контроля доступа к объекту строительства
 */
export type BuildingGroupRequestDto = {
  /**
   * Идентификатор группы.
   * # Тип: Guid
   */
  groupId: string
  /**
   * Идентификатор объекта строительства.
   * # Диапазон: 0..2147483647
   */
  buildingId: number
}
/**
 * Связка объекта строительства и группы пользователя.
 * Задает область ресурсов (resource scope), доступную пользователю.
 * Используется для контроля доступа к объекту строительства
 */
export type BuildingGroupResponseDto = {
  /**
   * Идентификатор группы.
   * # Тип: Guid
   */
  groupId: string
  /**
   * Идентификатор объекта строительства.
   * # Диапазон: 0..2147483647
   */
  buildingId: number
}
/**
 * Фильтр для запроса связей объектов строительства и группы пользователя.
 * При передаче массива в параметр фильтра элементы массива работают в выборке через ИЛИ.
 * При передаче нескольких разных параметров фильтра они работают в выборке через И
 */
export type BuildingGroupFilterRequestDto = {
  /**
   * По Идентификатору группы пользователя
   */
  groupIds?: string[]
  /**
   * По Объекту строительства
   */
  buildingIds?: number[]
}
/**
 * Фильтр для запроса связей объектов строительства и группы пользователя.
 * При передаче массива в параметр фильтра элементы массива работают в выборке через ИЛИ.
 * При передаче нескольких разных параметров фильтра они работают в выборке через И
 */
export type BuildingGroupFilterResponseDto = {
  /**
   * По Идентификатору группы пользователя
   */
  groupIds: string[]
  /**
   * По Объекту строительства
   */
  buildingIds: number[]
}
/**
 * Пагинация связей объектов строительства и группы пользователя
 */
export type BuildingGroupPagingRequestDto = {
  /**
   * Тип значения сортировки.
   * По умолчанию: ID
   */
  orderByType?: BuildingGroupPagingOrderByTypeRequestEnum | "ORDER_BY_TYPE_UNKNOWN"
  /**
   * Тип направления сортировки.
   * По умолчанию: DESC
   */
  directionType?: BuildingGroupPagingDirectionTypeRequestEnum | "DIRECTION_TYPE_UNKNOWN"
  /**
   * Количество записей на страницу.
   * Минимальное значение: 1.
   * Максимальное значение: 100.
   * По умолчанию: 20.
   * Если значение 0 (не передано), то выставляем значение по умолчанию
   */
  limit?: number
  /**
   * Сдвиг.
   * По умолчанию: 0
   */
  offset?: number
}
/**
 * Пагинация связей объектов строительства и группы пользователя
 */
export type BuildingGroupPagingResponseDto = {
  /**
   * Тип значения сортировки.
   * По умолчанию: ID
   */
  orderByType: BuildingGroupPagingOrderByTypeResponseEnum
  /**
   * Тип направления сортировки.
   * По умолчанию: DESC
   */
  directionType: BuildingGroupPagingDirectionTypeResponseEnum
  /**
   * Количество записей на страницу.
   * Минимальное значение: 1.
   * Максимальное значение: 100.
   * По умолчанию: 20.
   * Если значение 0 (не передано), то выставляем значение по умолчанию
   */
  limit: number
  /**
   * Сдвиг.
   * По умолчанию: 0
   */
  offset: number
}
/**
 * Пагинация объектов строительства
 */
export type BuildingPagingRequestDto = {
  /**
   * Тип значения сортировки.
   * По умолчанию: ID
   */
  orderByType?: BuildingPagingOrderByTypeRequestEnum | "ORDER_BY_TYPE_UNKNOWN"
  /**
   * Тип направления сортировки.
   * По умолчанию: DESC
   */
  directionType?: BuildingPagingDirectionTypeRequestEnum | "DIRECTION_TYPE_UNKNOWN"
  /**
   * Количество записей на страницу.
   * Минимальное значение: 1.
   * Максимальное значение: 100.
   * По умолчанию: 20.
   * Если значение 0 (не передано), то выставляем значение по умолчанию
   */
  limit?: number
  /**
   * Сдвиг.
   * По умолчанию: 0
   */
  offset?: number
}
/**
 * Пагинация объектов строительства
 */
export type BuildingPagingResponseDto = {
  /**
   * Тип значения сортировки.
   * По умолчанию: ID
   */
  orderByType: BuildingPagingOrderByTypeResponseEnum
  /**
   * Тип направления сортировки.
   * По умолчанию: DESC
   */
  directionType: BuildingPagingDirectionTypeResponseEnum
  /**
   * Количество записей на страницу.
   * Минимальное значение: 1.
   * Максимальное значение: 100.
   * По умолчанию: 20.
   * Если значение 0 (не передано), то выставляем значение по умолчанию
   */
  limit: number
  /**
   * Сдвиг.
   * По умолчанию: 0
   */
  offset: number
}
/**
 * Запрос удаления объекта строительства
 */
export type DeleteBuildingRequestDto = {
  /**
   * Идентификатор
   */
  id: number
}
/**
 * Ответ на запрос удаления объекта строительства
 */
export type DeleteBuildingResponseDto = {
}
/**
 * Запрос получения количества объектов строительства
 */
export type GetBuildingCountRequestDto = {
  /**
   * Фильтр по индикаторам
   */
  filter?: BuildingFilterRequestDto | null
}
/**
 * Ответ на запрос получения количества объектов строительства
 */
export type GetBuildingCountResponseDto = {
}
/**
 * type
 */
& fm.OneOf<{
  /**
   * Всего индикаторов
   */
  readonly data: number
}>
/**
 * Запрос получения количества связей объектов строительства и группы пользователя
 */
export type GetBuildingGroupCountRequestDto = {
  /**
   * Фильтр связей объектов строительства и группы пользователя
   */
  filter?: BuildingGroupFilterRequestDto | null
}
/**
 * Ответ на запрос получения количества связей объектов строительства и группы пользователя
 */
export type GetBuildingGroupCountResponseDto = {
}
/**
 * type
 */
& fm.OneOf<{
  /**
   * Всего связей объектов строительства и группы пользователя
   */
  readonly data: number
}>
/**
 * Запрос получения списка
 */
export type GetBuildingGroupListRequestDto = {
  /**
   * Фильтр связей объектов строительства и группы пользователя
   */
  filter?: BuildingGroupFilterRequestDto | null
}
/**
 * pagination
 */
& fm.OptionalOneOf<{
  /**
   * Пагинация
   */
  readonly paging: BuildingGroupPagingRequestDto
}>
/**
 * Ответ на запрос получения списка связей объектов строительства и группы пользователя
 */
export type GetBuildingGroupListResponseDto = {
}
/**
 * type
 */
& fm.OneOf<{
  /**
   * Связь объекта строительства и группы пользователя
   */
  readonly data: BuildingGroupResponseDto
}>
/**
 * Запрос получения списка
 */
export type GetBuildingListRequestDto = {
  /**
   * Фильтр индикаторов
   */
  filter?: BuildingFilterRequestDto | null
}
/**
 * pagination
 */
& fm.OptionalOneOf<{
  /**
   * Пагинация по индикаторам
   */
  readonly paging: BuildingPagingRequestDto
}>
/**
 * Ответ на запрос получения списка объектов строительства
 */
export type GetBuildingListResponseDto = {
}
/**
 * type
 */
& fm.OneOf<{
  /**
   * Индикатор
   */
  readonly data: BuildingResponseDto
}>
/**
 * Запрос получения объекта строительства
 */
export type GetBuildingRequestDto = {
  /**
   * Идентификатор объекта строительства
   */
  id: number
}
/**
 * Ответ на запрос получения объекта строительства
 */
export type GetBuildingResponseDto = {
}
/**
 * type
 */
& fm.OneOf<{
  /**
   * Объект строительства
   */
  readonly data: BuildingResponseDto
}>
/**
 * Запрос создания задачи с клиента на сервере
 */
export type PostBuildingFullDuplexRequestDto = {
  /**
   * Идентификатор запроса
   */
  requestId: string
}
/**
 * task
 */
& fm.OneOf<{
  /**
   * Результат обработки объекта строительства на клиенте
   */
  readonly buildingAsyncStatus: PostBuildingFullDuplexRequestBuildingAsyncStatusDto
}>
/**
 * Результат обработки объекта строительства на клиенте
 */
export type PostBuildingFullDuplexRequestBuildingAsyncStatusDto = {
  /**
   * Идентификатор объекта строительства
   */
  buildingId: number
}
/**
 * type
 */
& fm.OptionalOneOf<{
  /**
   * Успех
   */
  readonly data: PostBuildingFullDuplexRequestBuildingAsyncStatusSuccessDto
  /**
   * Ошибка
   */
  readonly error: PostBuildingFullDuplexRequestBuildingAsyncStatusErrorDto
}>
/**
 * Ошибки обработки объекта строительства на клиенте
 */
export type PostBuildingFullDuplexRequestBuildingAsyncStatusErrorDto = {
}
/**
 * reason
 */
& fm.OneOf<{
  /**
   * Неизвестная ошибка
   */
  readonly unknown: PostBuildingFullDuplexRequestBuildingAsyncStatusErrorUnknownErrorDto
}>
/**
 * Ошибки обработки объекта строительства на клиенте
 */
export type PostBuildingFullDuplexRequestBuildingAsyncStatusErrorResponseDto = {
}
/**
 * reason
 */
& fm.OneOf<{
  /**
   * Неизвестная ошибка
   */
  readonly unknown: PostBuildingFullDuplexRequestBuildingAsyncStatusErrorUnknownErrorResponseDto
}>
/**
 * Неизвестная ошибка на стороне клиента
 */
export type PostBuildingFullDuplexRequestBuildingAsyncStatusErrorUnknownErrorDto = {
  /**
   * Произвольный текст ошибки на стороне клиента.
   * Отправляется в случае если в спецификации нет подходящей ошибки.
   * После анализа таких ошибок в спецификацию добавляется специальный тип под эту ошибку
   */
  message: string
}
/**
 * Неизвестная ошибка на стороне клиента
 */
export type PostBuildingFullDuplexRequestBuildingAsyncStatusErrorUnknownErrorResponseDto = {
  /**
   * Произвольный текст ошибки на стороне клиента.
   * Отправляется в случае если в спецификации нет подходящей ошибки.
   * После анализа таких ошибок в спецификацию добавляется специальный тип под эту ошибку
   */
  message: string
}
/**
 * Команда принята
 */
export type PostBuildingFullDuplexRequestBuildingAsyncStatusSuccessDto = {
}
/**
 * Событие создания/изменения объекта строительства на сервера
 */
export type PostBuildingFullDuplexResponseDto = {
  /**
   * Идентификатор запроса
   */
  requestId: string
}
/**
 * event
 */
& fm.OneOf<{
  /**
   * Событие создания/обновления объекта строительства
   */
  readonly upsertBuildingEvent: PostBuildingFullDuplexResponseUpsertBuildingEventDto
  /**
   * Событие удаления объекта строительства
   */
  readonly removeBuildingEvent: PostBuildingFullDuplexResponseRemoveBuildingEventDto
}>
/**
 * Событие удаления объекта строительства
 */
export type PostBuildingFullDuplexResponseRemoveBuildingEventDto = {
  /**
   * Идентификатор объекта строительства
   */
  id: number
}
/**
 * Событие создания/обновления объекта строительства
 */
export type PostBuildingFullDuplexResponseUpsertBuildingEventDto = {
  /**
   * Объект строительства
   */
  data: BuildingResponseDto
}
/**
 * Запрос сохранения объекта строительства
 */
export type PostBuildingRequestDto = {
  /**
   * Объект строительства
   */
  data: BuildingRequestDto
}
/**
 * Ответ на запрос сохранения объекта строительства
 */
export type PostBuildingResponseDto = {
}
/**
 * type
 */
& fm.OneOf<{
  /**
   * Объект строительства
   */
  readonly data: BuildingResponseDto
}>
/**
 * Запрос сохранения связей объектов строительства и группы пользователя
 */
export type PutBuildingGroupAttachRequestDto = {
  /**
   * Связь объекта строительства и группы пользователя
   */
  buildingGroup: BuildingGroupRequestDto
}
/**
 * Ответ на запрос сохранения связи объекта строительства и группы пользователя
 */
export type PutBuildingGroupAttachResponseDto = {
}
/**
 * Запрос удаления связей объектов строительства и группы пользователя
 */
export type PutBuildingGroupDetachRequestDto = {
  /**
   * Связь объекта строительства и группы пользователя
   */
  buildingGroup: BuildingGroupRequestDto
}
/**
 * Ответ на запрос удаления связи объекта строительства и группы пользователя
 */
export type PutBuildingGroupDetachResponseDto = {
}
/**
 * Дескриптор
 */
export const descriptor = {
  /**
   * Объект строительства
   */
  "Building": {
    "kind": "class",
    "text": "Объект строительства",
    "fields": {
      /**
       * Идентификатор
       */
      "id": {
        "type": "int32",
        "text": "Идентификатор",
      },
      /**
       * Наименование объекта строительства
       */
      "title": {
        "type": "string",
        "text": "Наименование объекта строительства",
      },
      /**
       * Дата создания
       */
      "createdAt": {
        "type": "google.protobuf.Timestamp",
        "text": "Дата создания",
      },
      /**
       * Дата последнего изменения.
       * Заполняется и обновляется сервером.
       * Заполняется при создании и изменении.
       * Является версией объекта
       */
      "changedAt": {
        "type": "google.protobuf.Timestamp",
        "text": "Дата последнего изменения.\nЗаполняется и обновляется сервером.\nЗаполняется при создании и изменении.\nЯвляется версией объекта",
      },
      /**
       * Смещение временной зоны объекта строительства от UTC в минутах
       */
      "utcOffset": {
        "type": "int32",
        "text": "Смещение временной зоны объекта строительства от UTC в минутах",
        "rules": {
          "required": "Значение обязательно для заполнения",
        }
      },
      /**
       * ФИАС
       */
      "fiasId": {
        "type": "google.protobuf.StringValue",
        "text": "ФИАС",
      },
      /**
       * Принадлежность объекта строительства к МРФ
       */
      "mrfType": {
        "type": "Building.MrfType",
        "text": "Принадлежность объекта строительства к МРФ",
      },
      /**
       * Принадлежность объекта строительства к РФ
       */
      "rfType": {
        "type": "Building.RfType",
        "text": "Принадлежность объекта строительства к РФ",
      },
      /**
       * Статус объекта строительства
       */
      "statusType": {
        "type": "Building.StatusType",
        "text": "Статус объекта строительства",
      },
      /**
       * Адрес объекта строительства
       */
      "fullAddress": {
        "type": "string",
        "text": "Адрес объекта строительства",
      },
      /**
       * ОРПОН
       */
      "orpon": {
        "type": "int64",
        "text": "ОРПОН",
      },
    },
  },
  /**
   * Фильтр для запроса объектов строительства.
   * При передаче массива в параметр фильтра элементы массива работают в выборке через ИЛИ.
   * При передаче нескольких разных параметров фильтра они работают в выборке через И
   */
  "BuildingFilter": {
    "kind": "class",
    "text": "Фильтр для запроса объектов строительства.\nПри передаче массива в параметр фильтра элементы массива работают в выборке через ИЛИ.\nПри передаче нескольких разных параметров фильтра они работают в выборке через И",
    "fields": {
      /**
       * По ФИАС
       */
      "fiasId": {
        "type": "google.protobuf.StringValue",
        "text": "По ФИАС",
      },
      /**
       * По заголовку
       */
      "title": {
        "type": "google.protobuf.StringValue",
        "text": "По заголовку",
      },
      /**
       * По нижней границе дате создания
       */
      "afterCreatedAt": {
        "type": "google.protobuf.Timestamp",
        "text": "По нижней границе дате создания",
      },
      /**
       * По верхней границе дате создания
       */
      "beforeCreatedAt": {
        "type": "google.protobuf.Timestamp",
        "text": "По верхней границе дате создания",
      },
      /**
       * По МРФ (Макрорегион)
       */
      "mrfTypes": {
        "type": "Building.MrfType",
        "text": "По МРФ (Макрорегион)",
      },
      /**
       * По РФ (Регион)
       */
      "rfTypes": {
        "type": "Building.RfType",
        "text": "По РФ (Регион)",
      },
      /**
       * По статусам объекта строительства
       */
      "statusTypes": {
        "type": "Building.StatusType",
        "text": "По статусам объекта строительства",
      },
      /**
       * По ОРПОНам
       */
      "orpons": {
        "type": "int64",
        "text": "По ОРПОНам",
      },
    },
  },
  /**
   * Связка объекта строительства и группы пользователя.
   * Задает область ресурсов (resource scope), доступную пользователю.
   * Используется для контроля доступа к объекту строительства
   */
  "BuildingGroup": {
    "kind": "class",
    "text": "Связка объекта строительства и группы пользователя.\nЗадает область ресурсов (resource scope), доступную пользователю.\nИспользуется для контроля доступа к объекту строительства",
    "fields": {
      /**
       * Идентификатор группы.
       * # Тип: Guid
       */
      "groupId": {
        "type": "string",
        "text": "Идентификатор группы.\n# Тип: Guid",
        "rules": {
          "required": "Значение обязательно для заполнения",
        }
      },
      /**
       * Идентификатор объекта строительства.
       * # Диапазон: 0..2147483647
       */
      "buildingId": {
        "type": "int32",
        "text": "Идентификатор объекта строительства.\n# Диапазон: 0..2147483647",
        "rules": {
          "required": "Значение обязательно для заполнения",
          "min": {
            "value": 0,
            "message": "Значение не входит в допустимый диапазон. Минимум: 0"
          },
          "max": {
            "value": 2147483647,
            "message": "Значение не входит в допустимый диапазон. Максимум: 2147483647"
          },
        }
      },
    },
  },
  /**
   * Фильтр для запроса связей объектов строительства и группы пользователя.
   * При передаче массива в параметр фильтра элементы массива работают в выборке через ИЛИ.
   * При передаче нескольких разных параметров фильтра они работают в выборке через И
   */
  "BuildingGroupFilter": {
    "kind": "class",
    "text": "Фильтр для запроса связей объектов строительства и группы пользователя.\nПри передаче массива в параметр фильтра элементы массива работают в выборке через ИЛИ.\nПри передаче нескольких разных параметров фильтра они работают в выборке через И",
    "fields": {
      /**
       * По Идентификатору группы пользователя
       */
      "groupIds": {
        "type": "string",
        "text": "По Идентификатору группы пользователя",
      },
      /**
       * По Объекту строительства
       */
      "buildingIds": {
        "type": "int32",
        "text": "По Объекту строительства",
      },
    },
  },
  /**
   * Пагинация связей объектов строительства и группы пользователя
   */
  "BuildingGroupPaging": {
    "kind": "class",
    "text": "Пагинация связей объектов строительства и группы пользователя",
    "fields": {
      /**
       * Тип значения сортировки.
       * По умолчанию: ID
       */
      "orderByType": {
        "type": "BuildingGroupPaging.OrderByType",
        "text": "Тип значения сортировки.\nПо умолчанию: ID",
      },
      /**
       * Тип направления сортировки.
       * По умолчанию: DESC
       */
      "directionType": {
        "type": "BuildingGroupPaging.DirectionType",
        "text": "Тип направления сортировки.\nПо умолчанию: DESC",
      },
      /**
       * Количество записей на страницу.
       * Минимальное значение: 1.
       * Максимальное значение: 100.
       * По умолчанию: 20.
       * Если значение 0 (не передано), то выставляем значение по умолчанию
       */
      "limit": {
        "type": "int32",
        "text": "Количество записей на страницу.\nМинимальное значение: 1.\nМаксимальное значение: 100.\nПо умолчанию: 20.\nЕсли значение 0 (не передано), то выставляем значение по умолчанию",
      },
      /**
       * Сдвиг.
       * По умолчанию: 0
       */
      "offset": {
        "type": "int32",
        "text": "Сдвиг.\nПо умолчанию: 0",
      },
    },
  },
  /**
   * Пагинация объектов строительства
   */
  "BuildingPaging": {
    "kind": "class",
    "text": "Пагинация объектов строительства",
    "fields": {
      /**
       * Тип значения сортировки.
       * По умолчанию: ID
       */
      "orderByType": {
        "type": "BuildingPaging.OrderByType",
        "text": "Тип значения сортировки.\nПо умолчанию: ID",
      },
      /**
       * Тип направления сортировки.
       * По умолчанию: DESC
       */
      "directionType": {
        "type": "BuildingPaging.DirectionType",
        "text": "Тип направления сортировки.\nПо умолчанию: DESC",
      },
      /**
       * Количество записей на страницу.
       * Минимальное значение: 1.
       * Максимальное значение: 100.
       * По умолчанию: 20.
       * Если значение 0 (не передано), то выставляем значение по умолчанию
       */
      "limit": {
        "type": "int32",
        "text": "Количество записей на страницу.\nМинимальное значение: 1.\nМаксимальное значение: 100.\nПо умолчанию: 20.\nЕсли значение 0 (не передано), то выставляем значение по умолчанию",
      },
      /**
       * Сдвиг.
       * По умолчанию: 0
       */
      "offset": {
        "type": "int32",
        "text": "Сдвиг.\nПо умолчанию: 0",
      },
    },
  },
  /**
   * Запрос удаления объекта строительства
   */
  "DeleteBuildingRequest": {
    "kind": "class",
    "text": "Запрос удаления объекта строительства",
    "fields": {
      /**
       * Идентификатор
       */
      "id": {
        "type": "int32",
        "text": "Идентификатор",
        "rules": {
          "required": "Значение обязательно для заполнения",
        }
      },
    },
  },
  /**
   * Ответ на запрос удаления объекта строительства
   */
  "DeleteBuildingResponse": {
    "kind": "class",
    "text": "Ответ на запрос удаления объекта строительства",
  },
  /**
   * Запрос получения количества объектов строительства
   */
  "GetBuildingCountRequest": {
    "kind": "class",
    "text": "Запрос получения количества объектов строительства",
    "fields": {
      /**
       * Фильтр по индикаторам
       */
      "filter": {
        "type": "BuildingFilter",
        "text": "Фильтр по индикаторам",
      },
    },
  },
  /**
   * Ответ на запрос получения количества объектов строительства
   */
  "GetBuildingCountResponse": {
    "kind": "class",
    "text": "Ответ на запрос получения количества объектов строительства",
    "fields": {
      /**
       * Всего индикаторов
       */
      "data": {
        "type": "int32",
        "text": "Всего индикаторов",
      },
    },
  },
  /**
   * Запрос получения количества связей объектов строительства и группы пользователя
   */
  "GetBuildingGroupCountRequest": {
    "kind": "class",
    "text": "Запрос получения количества связей объектов строительства и группы пользователя",
    "fields": {
      /**
       * Фильтр связей объектов строительства и группы пользователя
       */
      "filter": {
        "type": "BuildingGroupFilter",
        "text": "Фильтр связей объектов строительства и группы пользователя",
      },
    },
  },
  /**
   * Ответ на запрос получения количества связей объектов строительства и группы пользователя
   */
  "GetBuildingGroupCountResponse": {
    "kind": "class",
    "text": "Ответ на запрос получения количества связей объектов строительства и группы пользователя",
    "fields": {
      /**
       * Всего связей объектов строительства и группы пользователя
       */
      "data": {
        "type": "int32",
        "text": "Всего связей объектов строительства и группы пользователя",
      },
    },
  },
  /**
   * Запрос получения списка
   */
  "GetBuildingGroupListRequest": {
    "kind": "class",
    "text": "Запрос получения списка",
    "fields": {
      /**
       * Фильтр связей объектов строительства и группы пользователя
       */
      "filter": {
        "type": "BuildingGroupFilter",
        "text": "Фильтр связей объектов строительства и группы пользователя",
      },
      /**
       * Пагинация
       */
      "paging": {
        "type": "BuildingGroupPaging",
        "text": "Пагинация",
      },
    },
  },
  /**
   * Ответ на запрос получения списка связей объектов строительства и группы пользователя
   */
  "GetBuildingGroupListResponse": {
    "kind": "class",
    "text": "Ответ на запрос получения списка связей объектов строительства и группы пользователя",
    "fields": {
      /**
       * Связь объекта строительства и группы пользователя
       */
      "data": {
        "type": "BuildingGroup",
        "text": "Связь объекта строительства и группы пользователя",
      },
    },
  },
  /**
   * Запрос получения списка
   */
  "GetBuildingListRequest": {
    "kind": "class",
    "text": "Запрос получения списка",
    "fields": {
      /**
       * Фильтр индикаторов
       */
      "filter": {
        "type": "BuildingFilter",
        "text": "Фильтр индикаторов",
      },
      /**
       * Пагинация по индикаторам
       */
      "paging": {
        "type": "BuildingPaging",
        "text": "Пагинация по индикаторам",
      },
    },
  },
  /**
   * Ответ на запрос получения списка объектов строительства
   */
  "GetBuildingListResponse": {
    "kind": "class",
    "text": "Ответ на запрос получения списка объектов строительства",
    "fields": {
      /**
       * Индикатор
       */
      "data": {
        "type": "Building",
        "text": "Индикатор",
      },
    },
  },
  /**
   * Запрос получения объекта строительства
   */
  "GetBuildingRequest": {
    "kind": "class",
    "text": "Запрос получения объекта строительства",
    "fields": {
      /**
       * Идентификатор объекта строительства
       */
      "id": {
        "type": "int32",
        "text": "Идентификатор объекта строительства",
        "rules": {
          "required": "Значение обязательно для заполнения",
        }
      },
    },
  },
  /**
   * Ответ на запрос получения объекта строительства
   */
  "GetBuildingResponse": {
    "kind": "class",
    "text": "Ответ на запрос получения объекта строительства",
    "fields": {
      /**
       * Объект строительства
       */
      "data": {
        "type": "Building",
        "text": "Объект строительства",
      },
    },
  },
  /**
   * Запрос создания задачи с клиента на сервере
   */
  "PostBuildingFullDuplexRequest": {
    "kind": "class",
    "text": "Запрос создания задачи с клиента на сервере",
    "fields": {
      /**
       * Идентификатор запроса
       */
      "requestId": {
        "type": "string",
        "text": "Идентификатор запроса",
        "rules": {
          "required": "Значение обязательно для заполнения",
        }
      },
      /**
       * Результат обработки объекта строительства на клиенте
       */
      "buildingAsyncStatus": {
        "type": "PostBuildingFullDuplexRequest.BuildingAsyncStatus",
        "text": "Результат обработки объекта строительства на клиенте",
      },
    },
  },
  /**
   * Результат обработки объекта строительства на клиенте
   */
  "PostBuildingFullDuplexRequest.BuildingAsyncStatus": {
    "kind": "class",
    "text": "Результат обработки объекта строительства на клиенте",
    "fields": {
      /**
       * Идентификатор объекта строительства
       */
      "buildingId": {
        "type": "int32",
        "text": "Идентификатор объекта строительства",
        "rules": {
          "required": "Значение обязательно для заполнения",
        }
      },
      /**
       * Успех
       */
      "data": {
        "type": "PostBuildingFullDuplexRequest.BuildingAsyncStatus.Success",
        "text": "Успех",
      },
      /**
       * Ошибка
       */
      "error": {
        "type": "PostBuildingFullDuplexRequest.BuildingAsyncStatus.Error",
        "text": "Ошибка",
      },
    },
  },
  /**
   * Ошибки обработки объекта строительства на клиенте
   */
  "PostBuildingFullDuplexRequest.BuildingAsyncStatus.Error": {
    "kind": "class",
    "text": "Ошибки обработки объекта строительства на клиенте",
    "fields": {
      /**
       * Неизвестная ошибка
       */
      "unknown": {
        "type": "PostBuildingFullDuplexRequest.BuildingAsyncStatus.Error.UnknownError",
        "text": "Неизвестная ошибка",
      },
    },
  },
  /**
   * Неизвестная ошибка на стороне клиента
   */
  "PostBuildingFullDuplexRequest.BuildingAsyncStatus.Error.UnknownError": {
    "kind": "class",
    "text": "Неизвестная ошибка на стороне клиента",
    "fields": {
      /**
       * Произвольный текст ошибки на стороне клиента.
       * Отправляется в случае если в спецификации нет подходящей ошибки.
       * После анализа таких ошибок в спецификацию добавляется специальный тип под эту ошибку
       */
      "message": {
        "type": "string",
        "text": "Произвольный текст ошибки на стороне клиента.\nОтправляется в случае если в спецификации нет подходящей ошибки.\nПосле анализа таких ошибок в спецификацию добавляется специальный тип под эту ошибку",
        "rules": {
          "required": "Значение обязательно для заполнения",
        }
      },
    },
  },
  /**
   * Команда принята
   */
  "PostBuildingFullDuplexRequest.BuildingAsyncStatus.Success": {
    "kind": "class",
    "text": "Команда принята",
  },
  /**
   * Событие создания/изменения объекта строительства на сервера
   */
  "PostBuildingFullDuplexResponse": {
    "kind": "class",
    "text": "Событие создания/изменения объекта строительства на сервера",
    "fields": {
      /**
       * Идентификатор запроса
       */
      "requestId": {
        "type": "string",
        "text": "Идентификатор запроса",
        "rules": {
          "required": "Значение обязательно для заполнения",
        }
      },
      /**
       * Событие создания/обновления объекта строительства
       */
      "upsertBuildingEvent": {
        "type": "PostBuildingFullDuplexResponse.UpsertBuildingEvent",
        "text": "Событие создания/обновления объекта строительства",
      },
      /**
       * Событие удаления объекта строительства
       */
      "removeBuildingEvent": {
        "type": "PostBuildingFullDuplexResponse.RemoveBuildingEvent",
        "text": "Событие удаления объекта строительства",
      },
    },
  },
  /**
   * Событие удаления объекта строительства
   */
  "PostBuildingFullDuplexResponse.RemoveBuildingEvent": {
    "kind": "class",
    "text": "Событие удаления объекта строительства",
    "fields": {
      /**
       * Идентификатор объекта строительства
       */
      "id": {
        "type": "int32",
        "text": "Идентификатор объекта строительства",
        "rules": {
          "required": "Значение обязательно для заполнения",
        }
      },
    },
  },
  /**
   * Событие создания/обновления объекта строительства
   */
  "PostBuildingFullDuplexResponse.UpsertBuildingEvent": {
    "kind": "class",
    "text": "Событие создания/обновления объекта строительства",
    "fields": {
      /**
       * Объект строительства
       */
      "data": {
        "type": "Building",
        "text": "Объект строительства",
        "rules": {
          "required": "Значение обязательно для заполнения",
        }
      },
    },
  },
  /**
   * Запрос сохранения объекта строительства
   */
  "PostBuildingRequest": {
    "kind": "class",
    "text": "Запрос сохранения объекта строительства",
    "fields": {
      /**
       * Объект строительства
       */
      "data": {
        "type": "Building",
        "text": "Объект строительства",
        "rules": {
          "required": "Значение обязательно для заполнения",
        }
      },
    },
  },
  /**
   * Ответ на запрос сохранения объекта строительства
   */
  "PostBuildingResponse": {
    "kind": "class",
    "text": "Ответ на запрос сохранения объекта строительства",
    "fields": {
      /**
       * Объект строительства
       */
      "data": {
        "type": "Building",
        "text": "Объект строительства",
      },
    },
  },
  /**
   * Запрос сохранения связей объектов строительства и группы пользователя
   */
  "PutBuildingGroupAttachRequest": {
    "kind": "class",
    "text": "Запрос сохранения связей объектов строительства и группы пользователя",
    "fields": {
      /**
       * Связь объекта строительства и группы пользователя
       */
      "buildingGroup": {
        "type": "BuildingGroup",
        "text": "Связь объекта строительства и группы пользователя",
        "rules": {
          "required": "Значение обязательно для заполнения",
        }
      },
    },
  },
  /**
   * Ответ на запрос сохранения связи объекта строительства и группы пользователя
   */
  "PutBuildingGroupAttachResponse": {
    "kind": "class",
    "text": "Ответ на запрос сохранения связи объекта строительства и группы пользователя",
  },
  /**
   * Запрос удаления связей объектов строительства и группы пользователя
   */
  "PutBuildingGroupDetachRequest": {
    "kind": "class",
    "text": "Запрос удаления связей объектов строительства и группы пользователя",
    "fields": {
      /**
       * Связь объекта строительства и группы пользователя
       */
      "buildingGroup": {
        "type": "BuildingGroup",
        "text": "Связь объекта строительства и группы пользователя",
        "rules": {
          "required": "Значение обязательно для заполнения",
        }
      },
    },
  },
  /**
   * Ответ на запрос удаления связи объекта строительства и группы пользователя
   */
  "PutBuildingGroupDetachResponse": {
    "kind": "class",
    "text": "Ответ на запрос удаления связи объекта строительства и группы пользователя",
  },
  /**
   * Справочник МРФ (Макрорегионы)
   */
  "Building.MrfType": {
    "kind": "enum",
    "text": "Справочник МРФ (Макрорегионы)",
    "values": {
      /**
       * Значение не указано
       */
      "MRF_TYPE_UNKNOWN": {
        "i": 0,
        "text": "Значение не указано",
      },
      /**
       * Центр
       */
      "TSENTR": {
        "i": 1,
        "text": "Центр",
      },
      /**
       * Юг
       */
      "YUG": {
        "i": 2,
        "text": "Юг",
      },
      /**
       * Урал
       */
      "URAL": {
        "i": 3,
        "text": "Урал",
      },
      /**
       * Сибирь
       */
      "SIBIR": {
        "i": 4,
        "text": "Сибирь",
      },
      /**
       * Северо-Запад
       */
      "SEVERO_ZAPAD": {
        "i": 5,
        "text": "Северо-Запад",
      },
      /**
       * Дальний Восток
       */
      "DALNIY_VOSTOK": {
        "i": 6,
        "text": "Дальний Восток",
      },
      /**
       * Волга
       */
      "VOLGA": {
        "i": 7,
        "text": "Волга",
      },
    },
  },
  /**
   * Справочник РФ (Регионы)
   */
  "Building.RfType": {
    "kind": "enum",
    "text": "Справочник РФ (Регионы)",
    "values": {
      /**
       * Значение не указано
       */
      "RF_TYPE_UNKNOWN": {
        "i": 0,
        "text": "Значение не указано",
      },
      /**
       * Республика Башкортостан
       */
      "UFA": {
        "i": 1,
        "text": "Республика Башкортостан",
      },
      /**
       * Кировская область
       */
      "KIROV": {
        "i": 2,
        "text": "Кировская область",
      },
      /**
       * Ивановский филиал
       */
      "IVANOVO": {
        "i": 3,
        "text": "Ивановский филиал",
      },
      /**
       * Калужский филиал
       */
      "KALUGA": {
        "i": 4,
        "text": "Калужский филиал",
      },
      /**
       * Костромской филиал
       */
      "KOSTROMA": {
        "i": 5,
        "text": "Костромской филиал",
      },
      /**
       * Курский филиал
       */
      "KURSK": {
        "i": 6,
        "text": "Курский филиал",
      },
      /**
       * Липецкий филиал
       */
      "LIPETSK": {
        "i": 7,
        "text": "Липецкий филиал",
      },
      /**
       * Московская область
       */
      "MOSOBLAST": {
        "i": 8,
        "text": "Московская область",
      },
      /**
       * Орловский филиал
       */
      "OREL": {
        "i": 9,
        "text": "Орловский филиал",
      },
      /**
       * Рязанский филиал
       */
      "RYAZAN": {
        "i": 10,
        "text": "Рязанский филиал",
      },
      /**
       * Тамбовский филиал
       */
      "TAMBOV": {
        "i": 11,
        "text": "Тамбовский филиал",
      },
      /**
       * Тверской филиал
       */
      "TVER": {
        "i": 12,
        "text": "Тверской филиал",
      },
      /**
       * Ярославский филиал
       */
      "YAROSLAVL": {
        "i": 13,
        "text": "Ярославский филиал",
      },
      /**
       * Смоленский филиал
       */
      "SMOLENSK": {
        "i": 14,
        "text": "Смоленский филиал",
      },
      /**
       * Тульский филиал
       */
      "TULA": {
        "i": 15,
        "text": "Тульский филиал",
      },
      /**
       * Москва
       */
      "MOSCOW": {
        "i": 16,
        "text": "Москва",
      },
      /**
       * ЕАО
       */
      "EAO": {
        "i": 17,
        "text": "ЕАО",
      },
      /**
       * Филиал в Тюменской и Курганской областях
       */
      "KURGAN": {
        "i": 18,
        "text": "Филиал в Тюменской и Курганской областях",
      },
      /**
       * Филиал в Тюменской и Курганской областях
       */
      "TUMEN": {
        "i": 19,
        "text": "Филиал в Тюменской и Курганской областях",
      },
      /**
       * Ханты-Мансийский филиал
       */
      "HANTY": {
        "i": 20,
        "text": "Ханты-Мансийский филиал",
      },
      /**
       * Амурская область
       */
      "AMUR": {
        "i": 21,
        "text": "Амурская область",
      },
      /**
       * Камчатский край
       */
      "KAMCHATKA": {
        "i": 22,
        "text": "Камчатский край",
      },
      /**
       * Магаданская область
       */
      "MAGADAN": {
        "i": 23,
        "text": "Магаданская область",
      },
      /**
       * Приморский край
       */
      "PRIMORYE": {
        "i": 24,
        "text": "Приморский край",
      },
      /**
       * Сахалинская область
       */
      "SAKHALIN": {
        "i": 25,
        "text": "Сахалинская область",
      },
      /**
       * Хабаровский край
       */
      "KHABAROVSK": {
        "i": 26,
        "text": "Хабаровский край",
      },
      /**
       * Забайкальский край
       */
      "CHITA": {
        "i": 27,
        "text": "Забайкальский край",
      },
      /**
       * ЧАО
       */
      "CHUKOTKA": {
        "i": 28,
        "text": "ЧАО",
      },
      /**
       * Архангельск
       */
      "ARCHANGELSK": {
        "i": 29,
        "text": "Архангельск",
      },
      /**
       * Вологда
       */
      "VOLOGDA": {
        "i": 30,
        "text": "Вологда",
      },
      /**
       * Калининград
       */
      "KALININGRAD": {
        "i": 31,
        "text": "Калининград",
      },
      /**
       * Карелия
       */
      "KARELIA": {
        "i": 32,
        "text": "Карелия",
      },
      /**
       * Коми
       */
      "KOMI": {
        "i": 33,
        "text": "Коми",
      },
      /**
       * Лен область
       */
      "LENOBLAST": {
        "i": 34,
        "text": "Лен область",
      },
      /**
       * Мурманск
       */
      "MURMANSK": {
        "i": 35,
        "text": "Мурманск",
      },
      /**
       * Новгород
       */
      "NOVGOROD": {
        "i": 36,
        "text": "Новгород",
      },
      /**
       * Псков
       */
      "PSKOV": {
        "i": 37,
        "text": "Псков",
      },
      /**
       * СПб
       */
      "SPB": {
        "i": 38,
        "text": "СПб",
      },
      /**
       * Алтайский филиал
       */
      "ALTAI": {
        "i": 39,
        "text": "Алтайский филиал",
      },
      /**
       * Бурятский филиал
       */
      "BURYATIYA": {
        "i": 40,
        "text": "Бурятский филиал",
      },
      /**
       * Иркутский филиал
       */
      "IRKUTSK": {
        "i": 41,
        "text": "Иркутский филиал",
      },
      /**
       * Кемеровский филиал
       */
      "KEMEROVO": {
        "i": 42,
        "text": "Кемеровский филиал",
      },
      /**
       * Красноярский филиал
       */
      "KRASNOYARSK": {
        "i": 43,
        "text": "Красноярский филиал",
      },
      /**
       * Омский филиал
       */
      "OMSK": {
        "i": 44,
        "text": "Омский филиал",
      },
      /**
       * Республика Хакасия
       */
      "HAKASIYA": {
        "i": 45,
        "text": "Республика Хакасия",
      },
      /**
       * Республика Алтай
       */
      "RALTAY": {
        "i": 46,
        "text": "Республика Алтай",
      },
      /**
       * Республика Тыва
       */
      "TUVA": {
        "i": 47,
        "text": "Республика Тыва",
      },
      /**
       * Томский филиал
       */
      "TOMSK": {
        "i": 48,
        "text": "Томский филиал",
      },
      /**
       * Оренбургская область
       */
      "ORENBURG": {
        "i": 49,
        "text": "Оренбургская область",
      },
      /**
       * Белгородский филиал
       */
      "BELGOROD": {
        "i": 50,
        "text": "Белгородский филиал",
      },
      /**
       * Саха
       */
      "SAKHA": {
        "i": 51,
        "text": "Саха",
      },
      /**
       * Екатеринбургский филиал
       */
      "EKT": {
        "i": 52,
        "text": "Екатеринбургский филиал",
      },
      /**
       * Волгоградский филиал
       */
      "VOLGOGRAD": {
        "i": 53,
        "text": "Волгоградский филиал",
      },
      /**
       * Ямало-Ненецкий филиал
       */
      "YAMAL": {
        "i": 54,
        "text": "Ямало-Ненецкий филиал",
      },
      /**
       * Челябинский филиал
       */
      "CHELYABINSK": {
        "i": 55,
        "text": "Челябинский филиал",
      },
      /**
       * Пермский филиал ПАО \"Ростелеком\"
       */
      "PERM": {
        "i": 56,
        "text": "Пермский филиал ПАО \"Ростелеком\"",
      },
      /**
       * Республика Марий Эл
       */
      "MARYEL": {
        "i": 57,
        "text": "Республика Марий Эл",
      },
      /**
       * Пензенская область
       */
      "PENZA": {
        "i": 58,
        "text": "Пензенская область",
      },
      /**
       * Ингушский филиал
       */
      "INGUSHETIA": {
        "i": 59,
        "text": "Ингушский филиал",
      },
      /**
       * Кабардино-Балкарский филиал
       */
      "NALCHIK": {
        "i": 60,
        "text": "Кабардино-Балкарский филиал",
      },
      /**
       * Калмыцкий филиал
       */
      "ELISTA": {
        "i": 61,
        "text": "Калмыцкий филиал",
      },
      /**
       * Ростовский филиал
       */
      "ROSTOV": {
        "i": 62,
        "text": "Ростовский филиал",
      },
      /**
       * Дагестанский филиал
       */
      "MAHACHKALA": {
        "i": 63,
        "text": "Дагестанский филиал",
      },
      /**
       * Республика Мордовия
       */
      "MORDOVIYA": {
        "i": 64,
        "text": "Республика Мордовия",
      },
      /**
       * Республика Татарстан (Татарстан)
       */
      "KAZAN": {
        "i": 65,
        "text": "Республика Татарстан (Татарстан)",
      },
      /**
       * Самарская область
       */
      "SAMARA": {
        "i": 66,
        "text": "Самарская область",
      },
      /**
       * Саратовская область
       */
      "SARATOV": {
        "i": 67,
        "text": "Саратовская область",
      },
      /**
       * Удмуртская Республика
       */
      "UDMURTIYA": {
        "i": 68,
        "text": "Удмуртская Республика",
      },
      /**
       * Ульяновская область
       */
      "ULYANOVSK": {
        "i": 69,
        "text": "Ульяновская область",
      },
      /**
       * Чувашская Республика - Чувашия
       */
      "CHUVASHIYA": {
        "i": 70,
        "text": "Чувашская Республика - Чувашия",
      },
      /**
       * Нижегородская область
       */
      "NNOVGOROD": {
        "i": 71,
        "text": "Нижегородская область",
      },
      /**
       * Брянский филиал
       */
      "BRYANSK": {
        "i": 72,
        "text": "Брянский филиал",
      },
      /**
       * Владимирский филиал
       */
      "VLADIMIR": {
        "i": 73,
        "text": "Владимирский филиал",
      },
      /**
       * Воронежский филиал
       */
      "VORONEZH": {
        "i": 74,
        "text": "Воронежский филиал",
      },
      /**
       * Северо-Осетинский филиал
       */
      "VLADIKAVKAZ": {
        "i": 75,
        "text": "Северо-Осетинский филиал",
      },
      /**
       * Ставропольский филиал
       */
      "STAVROPOL": {
        "i": 76,
        "text": "Ставропольский филиал",
      },
      /**
       * Республика Карачаево-Черкесская
       */
      "CHERKESSK": {
        "i": 77,
        "text": "Республика Карачаево-Черкесская",
      },
      /**
       * Республика Адыгея
       */
      "MAYKOP": {
        "i": 78,
        "text": "Республика Адыгея",
      },
      /**
       * Астраханский филиал
       */
      "ASTRAKHAN": {
        "i": 79,
        "text": "Астраханский филиал",
      },
      /**
       * Краснодарский филиал
       */
      "KRASNODAR": {
        "i": 80,
        "text": "Краснодарский филиал",
      },
      /**
       * Тестовый
       */
      "TEST": {
        "i": 81,
        "text": "Тестовый",
      },
      /**
       * Новосибирский филиал
       */
      "NOVOSIBIRSK": {
        "i": 82,
        "text": "Новосибирский филиал",
      },
    },
  },
  /**
   * Статусы объектов строительства
   */
  "Building.StatusType": {
    "kind": "enum",
    "text": "Статусы объектов строительства",
    "values": {
      /**
       * Значение не указано
       */
      "STATUS_TYPE_UNKNOWN": {
        "i": 0,
        "text": "Значение не указано",
      },
      /**
       * СМР
       */
      "BUILDING": {
        "i": 1,
        "text": "СМР",
      },
      /**
       * Реализован
       */
      "ACCEPTANCE": {
        "i": 2,
        "text": "Реализован",
      },
      /**
       * Обслуживание
       */
      "ACTIVE": {
        "i": 3,
        "text": "Обслуживание",
      },
      /**
       * Снят с обслуживания
       */
      "ARCHIVE": {
        "i": 4,
        "text": "Снят с обслуживания",
      },
      /**
       * Отказ от заключения договора
       */
      "CANCELLED": {
        "i": 5,
        "text": "Отказ от заключения договора",
      },
      /**
       * Тестовый
       */
      "TEST_STATUS_TYPE": {
        "i": 6,
        "text": "Тестовый",
      },
    },
  },
  /**
   * Справочник типов направлений сортировки
   */
  "BuildingGroupPaging.DirectionType": {
    "kind": "enum",
    "text": "Справочник типов направлений сортировки",
    "values": {
      /**
       * Значение не указано
       */
      "DIRECTION_TYPE_UNKNOWN": {
        "i": 0,
        "text": "Значение не указано",
      },
      /**
       * От большего к меньшему
       */
      "DESC": {
        "i": 1,
        "text": "От большего к меньшему",
      },
      /**
       * От меньшего к большему
       */
      "ASC": {
        "i": 2,
        "text": "От меньшего к большему",
      },
    },
  },
  /**
   * Справочник типов сортировки
   */
  "BuildingGroupPaging.OrderByType": {
    "kind": "enum",
    "text": "Справочник типов сортировки",
    "values": {
      /**
       * Значение не указано
       */
      "ORDER_BY_TYPE_UNKNOWN": {
        "i": 0,
        "text": "Значение не указано",
      },
      /**
       * По Идентификатору группы пользователя
       */
      "GROUP_ID": {
        "i": 1,
        "text": "По Идентификатору группы пользователя",
      },
      /**
       * По Объекту строительства
       */
      "BUILDING_ID": {
        "i": 2,
        "text": "По Объекту строительства",
      },
    },
  },
  /**
   * Справочник типов направлений сортировки
   */
  "BuildingPaging.DirectionType": {
    "kind": "enum",
    "text": "Справочник типов направлений сортировки",
    "values": {
      /**
       * Значение не указано
       */
      "DIRECTION_TYPE_UNKNOWN": {
        "i": 0,
        "text": "Значение не указано",
      },
      /**
       * От большего к меньшему
       */
      "DESC": {
        "i": 1,
        "text": "От большего к меньшему",
      },
      /**
       * От меньшего к большему
       */
      "ASC": {
        "i": 2,
        "text": "От меньшего к большему",
      },
    },
  },
  /**
   * Справочник типов сортировки
   */
  "BuildingPaging.OrderByType": {
    "kind": "enum",
    "text": "Справочник типов сортировки",
    "values": {
      /**
       * Значение не указано
       */
      "ORDER_BY_TYPE_UNKNOWN": {
        "i": 0,
        "text": "Значение не указано",
      },
      /**
       * По уникальному ключу
       */
      "ID": {
        "i": 1,
        "text": "По уникальному ключу",
      },
      /**
       * По наименованию
       */
      "TITLE": {
        "i": 2,
        "text": "По наименованию",
      },
      /**
       * По дате создания
       */
      "CREATED_AT": {
        "i": 3,
        "text": "По дате создания",
      },
      /**
       * По дате изменения
       */
      "CHANGED_AT": {
        "i": 4,
        "text": "По дате изменения",
      },
      /**
       * По ФИАС
       */
      "FIAS_ID": {
        "i": 5,
        "text": "По ФИАС",
      },
    },
  },
}